class DiveSiteGrid {
  constructor(section) {
    this.cards = section.querySelectorAll('.dive-grid__card');
    this.buttons = section.querySelectorAll('.dive-grid__filter-btn');
    this.empty = section.querySelector('.dive-grid__empty');
    this.buttons.forEach(btn =>
      btn.addEventListener('click', () => this.filter(btn.dataset.filter))
    );
  }

  filter(type) {
    this.buttons.forEach(btn => {
      const active = btn.dataset.filter === type;
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-pressed', active);
    });

    let visible = 0;
    this.cards.forEach(card => {
      const types = (card.dataset.types || '').split(' ');
      const show = type === 'all' || types.includes(type);
      card.classList.toggle('dive-grid__card--hidden', !show);
      if (show) visible++;
    });

    if (this.empty) this.empty.classList.toggle('visible', visible === 0);
  }
}

document.querySelectorAll('.dive-grid__section').forEach(el => new DiveSiteGrid(el));
